import * as React from "react";
import { connect } from "react-redux";
import Login from "../../screens/Login";
import { login } from "./actions";
export interface Props {
  logins: any;
}

export interface State {}
class LoginSection extends React.Component<Props, State> {
  render() {
    return (
      <Login
        logins={this.props.logins}
        logoutaction={this.props.logoutaction}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    logins: (value) => {
      dispatch(login(value));
    },
  };
}
const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, bindAction)(LoginSection);
